module.exports = __webpack_public_path__ + "static/img/seguros-bmi.4ac564d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aliados/seguros-bmi.png
// module id = FGcI
// module chunks = 0